<script setup lang="ts">
import { computed, watch } from 'vue';
import { useScreenOrientation } from '@vueuse/core';
import { useHead } from '@vueuse/head';
import { useI18n } from 'vue-i18n';
import { RouterView, useRoute } from 'vue-router';
import { useApp, useGlobal } from '@/composables';
import { Languages } from '@/types';

const { locale } = useI18n();
const { language } = useGlobal();
useApp();
const route = useRoute();

const canonicalUrl = computed(
  () => `${window.location.origin}${import.meta.env.BASE_URL}${route.path.substring(1)}`,
);

useHead({
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl,
    },
  ],
});

const { isSupported, lockOrientation } = useScreenOrientation();
if (isSupported.value) {
  lockOrientation('portrait-primary');
}

watch(
  language,
  (newValue) => {
    if (newValue) {
      locale.value = Object.keys(Languages).includes(newValue) ? Languages[newValue] : Languages.en;
    }
  },
  { immediate: true },
);
</script>

<template>
  <RouterView />
</template>
